import { Observable, throwError } from 'rxjs';
import { AuthService } from './../auth/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, concatMap, map } from 'rxjs/operators';
import { properties } from '../../app.properties';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.accessToken;
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    const isCheckUrl =
      request.url.endsWith('oauth/check_token') ||
      request.url.endsWith('oauth/token');

    const isAttachmenImage = request.url.endsWith('exams/attachments')

    if (isLoggedIn && isApiUrl && !isCheckUrl) {
      return this.checkToken(request).pipe(
        concatMap((result) => next.handle(result))
      );
    } else if (isLoggedIn && isApiUrl && isAttachmenImage) {
      return this.setAttachmentHeaders(request).pipe(
        concatMap((result) => next.handle(result))
      );
    } else {
      return next.handle(request);
    }
  }

  private checkToken(request: HttpRequest<any>) {
    const authCredentials = btoa(
      `${properties.apiWebClient}:${properties.apiWebClientPassword}`
    );
    return this.http
      .post<any>(environment.apiUrl + 'oauth/check_token', null, {
        headers: {
          Authorization: `Basic ${authCredentials}`,
        },
        params: {
          token: this.authenticationService.currentUserValue.accessToken,
        },
      })
      .pipe(
        map(() => {
          return request.clone({
            setHeaders: {
              Authorization: `Bearer ${this.authenticationService.currentUserValue.accessToken}`,
              'X-Frame-Options': 'SAMEORIGIN',
              'X-Content-Type-Options': 'nosniff',
              'Strict-Transport-Security': 'maxAgeSeconds=31536000',
              'X-XSS-Protection': '1; mode=block',
              'X-Permitted-Cross-Domain-Policies': 'none',
              'content-security-policy': 'default-src *  data: blob: filesystem: about: ws: wss: "unsafe-inline" "unsafe-eval"; script-src * data: blob: "unsafe-inline" "unsafe-eval"; connect-src * data: blob: "unsafe-inline"; img-src * data: blob: "unsafe-inline"; frame-src * data: blob: ; style-src * data: blob: "unsafe-inline"; font-src * data: blob: "unsafe-inline";',
            },
          });
        }),
        catchError(() => this.refreshToken(request))
      );
  }

  private setAttachmentHeaders(request: HttpRequest<any>) {
    // const authCredentials = btoa(
    //   `${properties.apiWebClient}:${properties.apiWebClientPassword}`
    // );
    console.log('lukieeeeeeee!!!!')
    return this.http
      .get<any>(environment.apiUrl + 'exams/attachments')
      .pipe(
        map(() => {
          return request.clone({
            setHeaders: {
              Authorization: `Bearer ${this.authenticationService.currentUserValue.accessToken}`,
              'X-Frame-Options': 'SAMEORIGIN',
              'X-Content-Type-Options': 'nosniff',
              'Strict-Transport-Security': 'maxAgeSeconds=31536000',
              'X-XSS-Protection': '1; mode=block',
              'X-Permitted-Cross-Domain-Policies': 'none',
              'content-security-policy': 'default-src *  data: blob: filesystem: about: ws: wss: "unsafe-inline" "unsafe-eval"; script-src * data: blob: "unsafe-inline" "unsafe-eval"; connect-src * data: blob: "unsafe-inline"; img-src * data: blob: "unsafe-inline"; frame-src * data: blob: ; style-src * data: blob: "unsafe-inline"; font-src * data: blob: "unsafe-inline";',
            },
          });
        }),
        catchError(() => this.refreshToken(request))
      );
  }

  private refreshToken(request: HttpRequest<any>) {
    const refreshTokenFormData = new FormData();
    refreshTokenFormData.append('grant_type', 'refresh_token');
    refreshTokenFormData.append(
      'refresh_token',
      this.authenticationService.currentUserValue.refreshToken
    );
    const authCredentials = btoa(
      `${properties.apiWebClient}:${properties.apiWebClientPassword}`
    );

    return this.http
      .post<any>(environment.apiUrl + 'oauth/token', refreshTokenFormData, {
        headers: {
          Authorization: `Basic ${authCredentials}`,
        },
      })
      .pipe(
        map((result) => {
          const currentUser = this.authenticationService.currentUserValue;
          currentUser.accessToken = result.access_token;
          this.authenticationService.createDataLocalStorage(currentUser);
          this.authenticationService.updateCurrentUser(currentUser);
          return request.clone({
            setHeaders: {
              Authorization: `Bearer ${currentUser.accessToken}`,
              'X-Frame-Options': 'SAMEORIGIN',
              'X-Content-Type-Options': 'nosniff',
              'Strict-Transport-Security': 'maxAgeSeconds=31536000',
              'X-XSS-Protection': '1; mode=block',
              'X-Permitted-Cross-Domain-Policies': 'none',
              'content-security-policy': 'default-src *  data: blob: filesystem: about: ws: wss: "unsafe-inline" "unsafe-eval"; script-src * data: blob: "unsafe-inline" "unsafe-eval"; connect-src * data: blob: "unsafe-inline"; img-src * data: blob: "unsafe-inline"; frame-src * data: blob: ; style-src * data: blob: "unsafe-inline"; font-src * data: blob: "unsafe-inline";',
            },
          });
        }),
        catchError((error) => {
          this.authenticationService.logout();
          return throwError(error);
        })
      );
  }
}
